import styled, { css } from 'styled-components';

export const ActionIconStyles = styled.button<{ $emphasize: boolean }>`
  cursor: pointer;
  border: none;
  padding: 0;
  margin: 0;
  background: transparent;
  outline-offset: 4px;
  border-radius: ${(p) => p.theme.token('border-radius-input-icon-hover-focus')};
  transition: background 300ms;

  &:focus,
  &:hover:not(:disabled) {
    /* Replace the default outline with some custom focus styles */
    outline: none;

    background: ${(p) => p.theme.token('background-focus')};
  }

  /* For browsers that support :focus-visible, undo the :focus
    behavior we just enabled, and enable it only on :focus-visible.
    This way the focus appearance is still activated on keyboard focus,
    but does not linger after a click. The more specific selector of
    the hover styles keeps it from being overridden by the broad
    selector of &:not(:focus-visible). */
  &:not(:focus-visible) {
    background: transparent;
  }
  &:focus-visible {
    background: ${(p) => p.theme.token('background-focus')};
  }

  &:disabled {
    cursor: not-allowed;
  }

  & > svg {
    transition: fill 300ms, stroke 300ms;
    stroke-width: 0;
    display: block;

    /* Prevents SVG-embedded tooltips from being shown, because we require title text at the button level anyway */
    pointer-events: none;
  }

  ${(p) =>
    p.$emphasize
      ? css`
          & > svg {
            stroke: ${p.theme.token('icon-form-input-action')};
            fill: ${p.theme.token('icon-form-input-action')};
          }
        `
      : css`
          & > svg {
            stroke: ${p.theme.token('icon-form-input-default')};
            fill: ${p.theme.token('icon-form-input-default')};
          }

          &:hover:not(:disabled) > svg,
          &:focus > svg {
            stroke: ${p.theme.token('icon-form-input-action')};
            fill: ${p.theme.token('icon-form-input-action')};
          }

          /* For browsers that support :focus-visible, undo the :focus
            behavior we just enabled, and enable it only on :focus-visible.
            This way the focus appearance is still activated on keyboard focus,
            but does not linger after a click. The more specific selector of
            the hover styles keeps it from being overridden by the broad
            selector of &:not(:focus-visible). */
          &:not(:focus-visible) > svg {
            stroke: ${p.theme.token('icon-form-input-default')};
            fill: ${p.theme.token('icon-form-input-default')};
          }
          &:focus-visible > svg {
            stroke: ${p.theme.token('icon-form-input-action')};
            fill: ${p.theme.token('icon-form-input-action')};
          }
        `}

  &:disabled > svg {
    stroke: ${(p) => p.theme.token('icon-disabled')};
    fill: ${(p) => p.theme.token('icon-disabled')};
  }
`;
